import React, { useEffect } from 'react'
import Badge from 'app/app/(client)/components/molecules/Badge/Badge'
import { useAppSelector } from 'app/app/(client)/hooks/redux-hook'
import { getOfferStatus } from 'app/app/(client)/utils/utils'
import { Offer, SyncStatus } from 'types/types'
import { StatusBadgeProps } from 'app/types/ui/opportunity'

interface StatusColumnProps {
  opportunityId: string
  SFSyncStatus: SyncStatus | undefined
  offer?: Offer
}
const StatusColumn: React.FC<StatusColumnProps> = ({ opportunityId, SFSyncStatus, offer }) => {
  const { data: appConfigData } = useAppSelector(state => state.configdata)
  const [statusObj, setStatusObj] = React.useState<StatusBadgeProps>({} as StatusBadgeProps)

  useEffect(() => {
    const currentOfferStatusObj = getOfferStatus(offer, appConfigData?.frontLineConfig, SFSyncStatus)
    setStatusObj(currentOfferStatusObj)
  }, [offer, SFSyncStatus, opportunityId, appConfigData?.frontLineConfig])

  const renderError = () => {
    if (SFSyncStatus?.syncError) {
      return <div className="text-12px mt-1.5 md:mt-0 text-invalid leading-4 md:w-[50%]">{SFSyncStatus.syncError}</div>
    }
    return <></>
  }

  return (
    <>
      <div className="flex flex-col md:flex-row w-full">
        <div className="flex gap-2 md:mr-3 md:w-[50%]">
          {statusObj?.label?.length > 0 && (
            <Badge id={`status-badge-${opportunityId}`} type="status" className="text-12px leading-4" {...statusObj} />
          )}
        </div>
        {renderError()}
      </div>
    </>
  )
}
export default StatusColumn
